var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1080.9 252h-60.938v-24h-108v24h-120v-120.01c0-14.219-13.078-23.988-27.301-23.988h-334.87c-14.219 0-21.828 9.7695-21.828 23.988v120.01h-132v-24h-96v24h-66.445c-58.332 0-101.55 53.172-101.55 111.52v648.88c0 58.332 43.223 103.61 101.55 103.61h967.38c58.359 0 107.07-45.277 107.07-103.61v-648.88c0-58.344-48.707-111.52-107.06-111.52zm-876.94 840v-828h48v828zm528-840h-276v-96h276zm204 840v-828h60v828z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.578ecfcfdd5ef5187f1a4c201b2e0547.svg";
export { ForwardRef as ReactComponent };